// src/utils/notificationUtils.js
import notificationService from '../services/notificationService';

export const notificationUtils = {
  // Check if notifications are supported
  isSupported: () => {
    return 'Notification' in window && 'serviceWorker' in navigator;
  },

  // Get current permission status
  getPermissionStatus: () => {
    if (!notificationUtils.isSupported()) return 'not-supported';
    return Notification.permission;
  },

  // Request notification permission
  requestPermission: async () => {
    if (!notificationUtils.isSupported()) {
      throw new Error('Notifications not supported');
    }
    
    try {
      const permission = await Notification.requestPermission();
      return permission;
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      throw error;
    }
  },

  // Show a test notification
  showTestNotification: () => {
    if (Notification.permission === 'granted') {
      const notification = new Notification('Biznie App Test', {
        body: 'This is a test notification from Biznie App',
        icon: '/favicon.png',
        badge: '/favicon.png',
        tag: 'test-notification'
      });

      setTimeout(() => {
        notification.close();
      }, 5000);

      return notification;
    }
    return null;
  },

  // Get FCM token
  getFCMToken: async () => {
    try {
      return await notificationService.getFCMToken();
    } catch (error) {
      console.error('Error getting FCM token:', error);
      throw error;
    }
  },

  // Update FCM token on server
  updateServerToken: async (token) => {
    try {
      return await notificationService.updateFCMToken(token);
    } catch (error) {
      console.error('Error updating server token:', error);
      throw error;
    }
  },

  // Initialize notifications for the app
  initializeNotifications: async () => {
    try {
      if (!notificationUtils.isSupported()) {
        console.warn('Notifications not supported in this browser');
        return false;
      }

      const initialized = await notificationService.initialize();
      return initialized;
    } catch (error) {
      console.error('Error initializing notifications:', error);
      return false;
    }
  }
};

export default notificationUtils;
